"use client";

import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "@/lib/utils";

function Label({
  className,
  size = "default",
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> & {
  size?: "sm" | "default";
}) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      data-size={size}
      className={cn(
        "flex items-center gap-2 leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        size === "default" && "text-sm",
        size === "sm" && "text-xs",
        className
      )}
      {...props}
    />
  );
}

export { Label };
